import { Injectable } from '@angular/core';
import {
    FuseNavigationItem,
    FuseNavigationService,
} from '@fuse/components/navigation';
import { FuseMockApiService } from '@fuse/lib/mock-api';
import { ApiService } from 'app/core/api/api.service';
import { NavigationService } from 'app/core/navigation/navigation.service';
// import { contacts } from 'app/mock-api/apps/contacts/data';
// import { tasks } from 'app/mock-api/apps/tasks/data';
import { cloneDeep } from 'lodash-es';
import { of, switchMap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SearchMockApi {
    private _defaultNavigation: FuseNavigationItem[] = [];
    // private readonly _contacts: any[] = contacts;
    // private readonly _tasks: any[] = tasks;

    /**
     * Constructor
     */
    constructor(
        private _fuseMockApiService: FuseMockApiService,
        private _fuseNavigationService: FuseNavigationService,
        private _navigationService: NavigationService,
        private _apiService: ApiService
    ) {
        this._navigationService.navigation$.subscribe((navigation: any) => {
            this._defaultNavigation =
                (navigation?.default as FuseNavigationItem[]) ?? [];
            this.registerHandlers();
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register Mock API handlers
     */
    registerHandlers(): void {
        // Get the flat navigation and store it
        const flatNavigation = this._fuseNavigationService.getFlatNavigation(
            this._defaultNavigation
        );

        // -----------------------------------------------------------------------------------------------------
        // @ Search results - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onPost('api/common/search')
            .reply(({ request }) => {
                const query = cloneDeep(request.body.query.toLowerCase());

                if (query === '') {
                    return of([200, { results: [] }]);
                }
                const pagesResults = cloneDeep(flatNavigation).filter(
                    (page) =>
                        (!page.hidden || !page.hidden(page)) &&
                        (page.title?.toLowerCase().includes(query) ||
                            (page.subtitle && page.subtitle.includes(query)))
                );

                // // Filter the tasks
                // const tasksResults = cloneDeep(this._tasks).filter((task) =>
                //     task.title.toLowerCase().includes(query)
                // );

                const results = [];

                if (pagesResults.length > 0) {
                    pagesResults.forEach((result: any) => {
                        result.value = result.title;
                    });

                    results.push({
                        id: 'pages',
                        label: 'Pages',
                        results: pagesResults,
                    });
                }

                // If there are tasks results...
                // if (tasksResults.length > 0) {
                //     // Normalize the results
                //     tasksResults.forEach((result) => {
                //         // Add a link
                //         result.link = '/apps/tasks/' + result.id;

                //         // Add the title as the value
                //         result.value = result.title;
                //     });

                //     // Add to the results
                //     results.push({
                //         id: 'tasks',
                //         label: 'Tasks',
                //         results: tasksResults,
                //     });
                // }

                // Return the response
                return this._apiService
                    .post<any[]>('admin/user/all?page=0&size=10', [
                        {
                            name: 'username',
                            value: query,
                        },
                    ])
                    .pipe(
                        switchMap((res: any) => {
                            const contactsResults = res.content.map(
                                (contact) => ({
                                    ...contact,
                                    link: `/players/${contact.id}/settings`,
                                    value: `${contact.username}`,
                                })
                            );

                            if (contactsResults.length > 0) {
                                results.unshift({
                                    id: 'contacts',
                                    label: 'Players',
                                    results: contactsResults,
                                });
                            }
                            return of([200, results]);
                        })
                    );
            });
    }
}
